import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import ModalTypes from '@/consts/app/modalTypes';
import useIsMobileOnlyLayout from '@/hooks/layout/useIsMobileOnlyLayout';
import useIsWelcomeMode from '@/hooks/useIsWelcomeMode';
import pushNotificationService from '@/services/pushNotification/pushNotificationService';
import notificationStorageService from '@/services/storage/notificationStorageService';
import {makeSelectVisibleGlobalModal} from '@/state/selectors/modal';
import {showEnableNotificationModal} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';

const useShowEnableNotificationModal = () => {
    const {isWelcomeMode, isAnimationFinished} = useIsWelcomeMode();
    const isMobileOnly = useIsMobileOnlyLayout();
    const isPromptClosed = notificationStorageService.getIsNotificationPromptClosed();
    const isEnableNotificationPopupVisible = useSelector(makeSelectVisibleGlobalModal(ModalTypes.ENABLE_NOTIFICATION));
    const isMobilePopupVisible = isMobileOnly && isEnableNotificationPopupVisible;

    useEffect(() => {
        const showModal = () => {
            setTimeout(() => {
                dispatch(showEnableNotificationModal());
            }, 1000);
        };

        const run = async () => {
            const shouldNotificationScreenBeDisplayed =
                await pushNotificationService.checkIfNotificationScreenShouldBeDisplayed();

            if (isPromptClosed || !shouldNotificationScreenBeDisplayed) {
                return;
            }

            if (isWelcomeMode && !isMobileOnly) {
                if (isAnimationFinished) {
                    showModal();
                }
            } else if (isMobileOnly) {
                dispatch(showEnableNotificationModal());
            } else {
                showModal();
            }
        };

        run();
    }, [isWelcomeMode, isAnimationFinished, isPromptClosed]);

    return isMobilePopupVisible;
};

export default useShowEnableNotificationModal;
